import useListLoader from '../base/useListLoader';
import { useRealTimeUpdates } from '../base/useRealTimeUpdates';

function responseToItems({ data }) {
  const { availabilities } = data;
  return availabilities.map((availability) => ({ ...availability, id: availability.userId }));
}

/**
 * Loads a user's availability from the Teamwork v3 API.
 */
export default function useAvailabilitiesV3Loader({ params, count, pageSize }) {
  const { state, refresh } = useListLoader({
    url: `/projects/api/v3/people/availability.json`,
    params,
    count,
    pageSize,
    responseToItems,
  });

  useRealTimeUpdates((event) => {
    if (event.type === 'task' || event.type === 'event') {
      refresh();
    }
  });

  return state;
}
